// extracted by mini-css-extract-plugin
export default {"root":"VatIcon_root__mHjHP","is-enabled":"VatIcon_is-enabled__pcdTH"};